<template>
  <v-card>
    <v-toolbar flat color="primary">
      <v-toolbar-title>Delete Account</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <div class="text--primary">
        Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <ConfirmDelete>
        Delete Account
      </ConfirmDelete>
    </v-card-actions>
  </v-card>
</template>

<script>
import ConfirmDelete from '@/Components/Profile/ConfirmDelete'
export default {
   components: {
      ConfirmDelete
   },
   data () {
      return {
         dialog: false,
      }
   }
}
</script>

<style>

</style>
